/**
 * Environment variables validation and configuration
 */
import Joi from 'joi';

// Define the schema for environment variables
const envSchema = Joi.object({
  VITE_BFF_BASE_URL: Joi.string().uri().required().description('API base URL'),
  VITE_CDN_URL: Joi.string().uri().required().description('CDN base URL'),
  VITE_FLAGSMITH_PERSONAL_TOKEN: Joi.string(),
  VITE_BRANDING: Joi.string().optional().description('Initial branding identifier'),
  VITE_FLAGSMITH_ENVIRONMENT_ID: Joi.string().optional().description('Flagsmith environment ID'),
  VITE_FLAGSMITH_API_URL: Joi.string().uri().optional().description('Flagsmith API URL'),
}).unknown(); // Allow other env variables

// Validate environment variables
const { error, value: envVars } = envSchema.validate(import.meta.env, {
  abortEarly: false,
  allowUnknown: true,
});

if (error) {
  throw new Error(
    `Environment validation error: ${error.details.map(detail => detail.message).join(', ')}`,
  );
}

// Export validated and typed environment variables
export const env = {
  bffBaseURL: envVars.VITE_BFF_BASE_URL,
  cdnURL: envVars.VITE_CDN_URL,
  branding: envVars.VITE_BRANDING,
  flagsmith: {
    environmentId: envVars.VITE_FLAGSMITH_ENVIRONMENT_ID,
    apiUrl: envVars.VITE_FLAGSMITH_API_URL,
  },
} as const;
